<template>
  <div>
    <el-table :data="projects">
      <el-table-column prop="userId" label="员工id"> </el-table-column>

      <el-table-column prop="coinType" label="币种"> </el-table-column>

      <el-table-column prop="amount" label="金额"> </el-table-column>

      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.balanceChangeStatus == 0"
            >奖励总冻结转账任务创建</span
          >
          <span v-else-if="scope.row.balanceChangeStatus == 1"
            >奖励总冻结转账任务执行成功</span
          >
          <span v-else-if="scope.row.balanceChangeStatus == -1"
            >奖励总冻结转账任务执行失败</span
          >
          <span v-else-if="scope.row.balanceChangeStatus == -2"
            >奖励总冻结转账任务执行超时</span
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';

export default {
  name: 'kpiProjectList',
  computed: {
    ...mapState('kpiProject', ['totalCount', 'pagination', 'projects']),
    ...mapGetters('kpiProject', ['projectList'])
  },
  components: {
    Pagination,
    Detail
  },
  methods: {
    ...mapMutations('kpiProject', ['setEditingProject']),
    viewDetail(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
